import classNames from 'classnames'

import React, { ForwardedRef, forwardRef } from 'react'
import { StepFormProps } from './StepForm.schema'

import SubmitButton from '@/submit-button/SubmitButton'
import Appear from '@/appear/Appear'
import Link from 'next/link'
import GridColumn from '../grid/components/GridCol'
import Grid from '../grid/components/Grid'

const StepForm = forwardRef<HTMLFormElement, StepFormProps>((props: StepFormProps, ref: ForwardedRef<HTMLFormElement>) => {
    const className = classNames('step-form', props.className)

    return (
        <form ref={ref} action={props.action} className={className} >
            {props.children}
            {!props.hideSubmitButton && (
                <Appear delay={450}>
                    {props.alternativeButton && <Grid gutter='none' justify={['between-xs']} align={['middle-xs']}>
                        <GridColumn width={['xxs-12', 'xs']}>
                            <SubmitButton
                                isUploading={props.isUploading}
                                label={props.submitLabel || 'Submit'}
                                disabled={props.submitDisabled}
                             />
                        </GridColumn>
                        <GridColumn width={['xxs-12', 'xs']}>
                            <Link href={props.alternativeButton}>
                                <b>{props.linkLabel}</b>
                            </Link>
                        </GridColumn>
                    </Grid>}
                    {!props.alternativeButton && (
                        <SubmitButton
                            isUploading={props.isUploading}
                            disabled={props.submitDisabled}
                            label={props.submitLabel || 'Submit'}
                        />
                    )}
                </Appear>
            )}
        </form>
    )
})

StepForm.displayName = 'StepForm'

export default StepForm
